const generateStepPrice = (price: number): number => {
  let newStep = 1;
  if (price > 200 && price <= 500) {
    newStep = 2;
  } else if (price > 500 && price <= 2000) {
    newStep = 5;
  } else if (price > 2000 && price <= 5000) {
    newStep = 10;
  } else if (price > 5000) {
    newStep = 25;
  }

  return newStep;
}

export default generateStepPrice;